import { render, staticRenderFns } from "./baiyi_browser.vue?vue&type=template&id=db8ac4ce&scoped=true&"
import script from "./baiyi_browser.vue?vue&type=script&lang=js&"
export * from "./baiyi_browser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8ac4ce",
  null
  
)

export default component.exports